var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPltrIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DDDDDD;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M137.8,538.1v-195h77c14.8,0,27.4,2.8,37.8,8.4c10.4,5.6,18.4,13.4,23.9,23.3c5.5,9.9,8.2,21.4,8.2,34.3 s-2.8,24.4-8.4,34.3c-5.6,9.9-13.7,17.6-24.2,23.1c-10.6,5.5-23.3,8.3-38.3,8.3h-49v-33H207c7.9,0,14.5-1.4,19.7-4.1 s9-6.6,11.6-11.5c2.6-4.9,3.9-10.6,3.9-17c0-6.5-1.3-12.1-3.9-17c-2.6-4.9-6.5-8.6-11.7-11.3c-5.2-2.7-11.8-4-19.8-4H179v161.3 H137.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.8,538.1v-195h41.2v161h83.6v34H301.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.6,377.1v-34h160.2v34h-59.7v161h-40.8v-161H412.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.6,538.1v-195h77c14.7,0,27.3,2.6,37.8,7.9c10.4,5.2,18.4,12.6,23.9,22.2c5.5,9.6,8.2,20.8,8.2,33.7 c0,13-2.8,24.1-8.4,33.4c-5.6,9.3-13.7,16.4-24.2,21.4s-23.3,7.4-38.3,7.4H614v-33.1h44.9c7.9,0,14.4-1.1,19.6-3.2 c5.2-2.2,9.1-5.4,11.7-9.7c2.6-4.3,3.9-9.7,3.9-16.1c0-6.5-1.3-11.9-3.9-16.4c-2.6-4.4-6.5-7.8-11.7-10.1 c-5.2-2.3-11.8-3.5-19.8-3.5h-27.8v161.3H589.6z M695,449.4l48.5,88.8h-45.5l-47.4-88.8H695z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPltrIcon);
export default __webpack_public_path__ + "static/media/pltr_icon.dbb7f80ddd28ecab6c05394440e4916e.svg";
export { ForwardRef as ReactComponent };